import { ExpenseType } from './Types';

const expenseTypeToStringMap: Record<ExpenseType, string> = {
  [ExpenseType.FIXED]: 'Fixo',
  [ExpenseType.VARIABLE]: 'Variável',
  [ExpenseType.INDIRECT]: 'Indireto',
};

const expenseTypeByCategoryMap: Record<string, ExpenseType> = {
  Aluguel: ExpenseType.FIXED,
  Aquisição: ExpenseType.FIXED,
  Seguro: ExpenseType.FIXED,
  DPVAT: ExpenseType.FIXED,
  'IPVA, taxas e impostos': ExpenseType.FIXED,
  Documentação: ExpenseType.FIXED,

  Depreciação: ExpenseType.INDIRECT,
  'Ferramentas de gestão': ExpenseType.INDIRECT,
  'Despesas administrativas': ExpenseType.INDIRECT,
  Desmobilização: ExpenseType.INDIRECT,
  'Ferramentas e acessórios': ExpenseType.INDIRECT,
  Outros: ExpenseType.INDIRECT,
  Salários: ExpenseType.INDIRECT,
  'Compra de itens e produtos': ExpenseType.INDIRECT,
  'Funcionários e ajudantes de viagem': ExpenseType.INDIRECT,

  Sinistro: ExpenseType.VARIABLE,
  'Multas e infrações': ExpenseType.VARIABLE,
  Pedágio: ExpenseType.VARIABLE,
  Estacionamento: ExpenseType.VARIABLE,
  Pneus: ExpenseType.VARIABLE,
  Lavagem: ExpenseType.VARIABLE,
  Arla: ExpenseType.VARIABLE,
  Serviços: ExpenseType.VARIABLE,
  Hospedagem: ExpenseType.VARIABLE,
  'Alimentação e refeição': ExpenseType.VARIABLE,
};

export { expenseTypeToStringMap, expenseTypeByCategoryMap };
